import React, { useEffect, useState } from "react";
import Header from "./Header";
import { useNavigate } from "react-router-dom";

import { apiURL } from "../../api";
import { AiFillCheckCircle } from "react-icons/ai";

function Orders(props) {
  const Navigate = useNavigate();
  const adminDetails = JSON.parse(localStorage.getItem("adminDetails"));
  const [message, setMessage] = useState("");

  const handleCheck = async (orderId) => {
    try {
      const res = await fetch(`${apiURL}/adminorders/${orderId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ status: "Delivered" }),
      });

      if (res.status === 200) {
        setMessage(
          "Congragulations! The Order Has Been Successfully Delivered"
        );
        setTimeout(() => {
          setMessage("");
        }, 2000);
      }
    } catch (error) {
      setMessage(
        "Sorry! Something Unexpected Occurred, Please Contact Your Customer"
      );
      setTimeout(() => {
        setMessage("");
      }, 2000);
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const OrdersPageLoaded = async () => {
      try {
        if (adminDetails.email === "" || adminDetails.password === "") {
          Navigate("/admin");
        } else {
          const res = await fetch(
            `${apiURL}/adminorders/${adminDetails.email}/${adminDetails.password}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          await res.json();
        }
      } catch (error) {
        Navigate("/admin");
      }
    };
    OrdersPageLoaded();
  }, [Navigate, adminDetails.email, adminDetails.password]);

  return (
    <>
      {message && (
        <div className="bg-green-600 text-white p-2 w-full text-center font-semibold absolute">
          {message}
        </div>
      )}
      <div className="dark:bg-dark" style={{ minHeight: "100vh" }}>
        <Header enableDarkMode={props.enableDarkMode} />
        <div className="flex justify-between items-center text-gray-600">
          <div className="w-[88%] mx-auto">
            <table className="w-full">
              <thead>
                <tr className="dark:bg-slate-800 dark:text-white bg-background text-gray-800">
                  <th className="py-2 px-4 font-semibold">Buyer</th>
                  <th className="py-2 px-4 font-semibold">Email</th>
                  <th className="py-2 px-4 font-semibold">Items</th>
                  <th className="py-2 px-4 font-semibold">Total</th>
                  <th className="py-2 px-4 font-semibold">Address</th>
                  <th className="py-2 px-4 font-semibold">Status</th>
                  <th className="py-2 px-4 font-semibold">Delivery</th>
                </tr>
              </thead>
              <tbody className="dark:bg-slate-500 dark:text-white">
                {props.orders.map((order) => {
                  return (
                    <tr className="text-center" key={order._id}>
                      <td className="py-2 px-4">{order.buyer}</td>
                      <td className="py-2 px-4">{order.email}</td>
                      <td className="py-2 px-4">{order.items}</td>
                      <td className="py-2 px-4">{order.total}</td>
                      <td className="py-2 px-4">{order.address}</td>
                      <td>
                        <button className="cursor-default py-1 px-4 bg-green-500 text-white rounded-sm">
                          Paid
                        </button>
                      </td>
                      <td>
                        {order.status === "Delivered" ? (
                          <span className="flex justify-center items-center">
                            <AiFillCheckCircle size="20" />
                          </span>
                        ) : (
                          <button
                            className="py-1 px-4 bg-gray-700 text-white rounded-sm"
                            onClick={() => handleCheck(order._id)}
                          >
                            Done
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default Orders;
